import React, { useState, useEffect } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";

const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const Season = ({ handleSeasonClick, lang, items, season }) => {
	const [hasWinterItems, setHasWinterItems] = useState(false);
	const [hasSummerItems, setHasSummerItems] = useState(false);
	const [hasAutumnItems, setHasAutumnItems] = useState(false);
	const [hasSpringItems, setHasSpringItems] = useState(false);

	useEffect(() => {
		if (items?.length > 0) {
			items.forEach(item => {
				if (
					item?.keywords &&
					item?.keywords.some(keyword => keyword.title.includes("Frühling"))
				) {
					setHasSpringItems(true);
				}
				if (
					item?.keywords &&
					item?.keywords.some(keyword => keyword.title.includes("Sommer"))
				) {
					setHasSummerItems(true);
				}
				if (
					item?.keywords &&
					item?.keywords.some(keyword => keyword.title.includes("Winter"))
				) {
					setHasWinterItems(true);
				}
				if (
					item?.keywords &&
					item?.keywords.some(keyword => keyword.title.includes("Herbst"))
				) {
					setHasAutumnItems(true);
				}
			});
		}
	}, [items]);

	return (
		<div className={clsx("video-player-root__buttons", "video-player-root__buttons--season")}>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": season === "Winter",
					"video-player-root__buttons-button--disabled": !hasWinterItems
				})}
				onClick={event => handleSeasonClick(event, "Winter")}
				title="Winter"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/winter.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": season === "Frühling",
					"video-player-root__buttons-button--disabled": !hasSpringItems
				})}
				onClick={event => handleSeasonClick(event, "Frühling")}
				title="Frühling"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/spring.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": season === "Sommer",
					"video-player-root__buttons-button--disabled": !hasSummerItems
				})}
				onClick={event => handleSeasonClick(event, "Sommer")}
				title="Sommer"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/summer.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": season === "Herbst",
					"video-player-root__buttons-button--disabled": !hasAutumnItems
				})}
				onClick={event => handleSeasonClick(event, "Herbst")}
				title="Herbst"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/autumn.svg" size={24} />
			</div>
			<span className={clsx("video-player-root__buttons-label")}>
				{lang === "de" ? "Jahreszeit" : "season"}
			</span>
		</div>
	);
};

export default Season;
